angular.module('listviewModule').component('listview', {
	templateUrl: 'listview/listview.html',
	transclude: true,
	bindings: {
		rows: '<',
		sortings: '<',
		filters: '<',
		allExpanded: '=',
		allCollapsed: '=',
		isActiveListingPage: '<',
		columnsIndex: '@',
		contentType: '@',
		searchType: '<',
		rpcSignin: '<',
		rpcSaveToProfile: '<',
		hrefSavedPage: '<',
		persistentTableHeader: '=',
		withPhotoOptions: '<',
		photoOptionType: '@',
		forPremiumBuilding: '<',
		sortType: '@',
		hideHeaders: '@',
		headerNotMoved: '<', // Don't move the header in the stalker
		fullWidth: '@',
		isRemovable: '@',
		isMobile: '<',
		rpcUrlAdd: '<',
		rpcUrlRemove: '<',
		rpcUrlAutocomplete: '<',
		rpcAddRentedApt: '<',
		placeholderAutocomplete: '<',
		activePortfolio: '<',
		expiresInThreshold: '<',
		buildingToManage: '<',
		userType: '<',
		user: '<',
		contactToken: '@',
		withAddRentedApts: '<', // To allow the user to add a rented apts on my listings
		useFullScreenPopup: '<',
		newlyAddedListingList: '<', // these are the list of maskid of the listing that the user just added to set the info in bold.
		companyPhone: '@',
		contactSource: '@',
		onSubmit: '&',
		onExpandAll: '&',
		onCollapseAll: '&',
		onToggleExpand: '&',
		onChangeExpand: '&',
		onSaveScrollPosition: '&',
		onSavePhotoOptionView: '&',
		onAdd: '&',
		onRemove: '&',
		onOpenEditStatus: '&',
		onChangeStatus: '&',
		onOpenRentStatus: '&',
		onEditListing: '&',
		onChangeAlert: '&',
		onRepeatDone: '&',
		onManageListings: '&',
		isForBuilding: '<',
		viewMoreOpensPopup: '<',
		pagination: '<',
		singlePage: '<',
		source: '@'
	},
	controller: ['$element', '$window', 'crResourcesService', 'ListviewService', '$timeout', '$cookies', 'PubSub', 'gVariables', '$filter', '$scope', function ($element, $window, crResourcesService, ListviewService, $timeout, $cookies, PubSub, gVariables, $filter, $scpe) {
		if (!this.useFullScreenPopup) {
			this.useFullScreenPopup = true;
		}
		this.pageId = gVariables.pageId;
		var w = angular.element($window);
		var stalker = angular.element(document.querySelector('.w_stalker'));
		var table = angular.element($element[0].querySelector('.cmp-table'));
		var ctrl = this;
		this.isGuest = G;
		this.isBroker = B;
		this.cSource = this.contactSource || "search-results";

		this.$onInit = () => {
			PubSub.subscribe('crMBuildingUnitsSummaryActivityTypeChange', (data) => {
				this.columnsIndex = data.columnsIndex;
				this.setColumns();
			});
	
			this.setColumns();
		};

		this.currentSort = this.sortings ? this.sortings.sort : undefined;
		this.currentDir = this.sortings ? this.sortings.dir : undefined;

		if (this.sortings && this.sortings.dir) {
			if (this.currentDir === 1) {
				this.orderProp = '-' + this.sortings.id;
			} else if (this.currentDir === 2) {
				this.orderProp = this.sortings.id;
			}
		}

		this.defaulthoodCharLimit = this.hoodCharLimit;
		this.oldWidth = 0;
		this.showPriceChange = false;
		this.styleHeader = {};

		this.trackerManagementCategory = window.pageType;
		this.trackerManagementAction = 'AptList';
		this.trackerManagementLabel = 'ManagementLink';

		// INIT
		// copy the header of the table into the stalker (to be able to display it on scroll)
		$timeout(function () {
			ctrl.header = angular.element(document.querySelector('.cr_toggle_view .cmp-table .header-stalker'));
			ctrl.tableTemplate = angular.element(document.querySelector('.w_stalker .cmp-listview'));

			if (!ctrl.headerNotMoved && ctrl.tableTemplate[0]) {
				var tab = angular.element(ctrl.tableTemplate[0].querySelector('.cmp-table'));

				if (tab) {
					tab.append(ctrl.header);
					if (ctrl.persistentTableHeader) {
						ctrl.updateStalkerTableSize();
					}
				}
			}

			// To display the pricechange if there's enough space
			ctrl.displayPriceChange();
		});

		// subscribe to the event from the side bar (move to left or right)
		PubSub.subscribe('updateStalkerTableHeader', function () {
			$timeout(function () {
				if (ctrl.persistentTableHeader) {
					ctrl.updateStalkerTableSize();
				}
			}, 300);
		});

		PubSub.subscribe("contact-form-propagate-token", function (token) {
			ctrl.contactToken = token;
		});

		this.setColumns = () => {
			this.columns = ListviewService.getColumns(this.columnsIndex);
			if (this.searchType !== 'searchclosed') {
				if (!this.isGuest) { // if user is logged in, then ignore the lock column
					if (this.columns['lock']) {
						delete this.columns['lock'];
					}
				}
			}
		};

		this.toggleShowExtras = function (row) {
			this.rows.forEach(d => d.showExtras = false);
			row.showExtras = true;
		}

		this.handleExpandKeydown = function (row, event) {
			const { which } = event;
			if (which === 13 || which == 32) {
				event.preventDefault();
				this.toggleExpand(row, event);
			}
		}

		this.updateStalkerTableSize = function () {
			if (table && this.tableTemplate && !!$element && !!$element[0] && typeof $element[0].getPosition === 'function') {
				this.styleHeader.left = $element[0].getPosition().x + 'px';
				this.styleHeader.width = $element[0].clientWidth + 'px';
			}
		};

		this.displayPriceChange = function () {
			var priceColumn = angular.element(document.querySelector('.column.price'));
			if (priceColumn.length === 0) return;


			var width = priceColumn[0].clientWidth;
			if (priceColumn.length > 0 && width > 95) {
				this.showPriceChange = true;
			} else {
				this.showPriceChange = false;
			}
		};

		w.bind('resize', function () {
			$timeout(function () {
				ctrl.displayPriceChange();
			});

			if (ctrl.persistentTableHeader) {
				ctrl.updateStalkerTableSize();
			}
		});

		w.bind('scroll', function () {
			if (ctrl.persistentTableHeader) {
				if (!!ctrl.isMobile) {
					let cmpTable = $element[0].querySelector('.cmp-table');
					if (!!cmpTable && cmpTable.getBoundingClientRect().y > 0) {
						if (ctrl.showHeaderStalker) {
							$timeout(function () {
								ctrl.showHeaderStalker = false;
							});
						}
					} else {
						if (!ctrl.showHeaderStalker) {
							$timeout(function () {
								ctrl.showHeaderStalker = true;
							});
						}
					}
				} else {
					let positionStalker = null;
					if (!!$window && typeof $window.getScroll === 'function' && !!$window.getScroll().y) {
						positionStalker = ($window.getScroll().y + $(stalker[0]).getSize().y);
					}
					if (!!positionStalker
						&& positionStalker > $(table[0]).getPosition().y
						&& $(table[0]).getBoundingClientRect().bottom > 0) {
						if (!ctrl.showHeaderStalker) {
							$timeout(function () {
								ctrl.showHeaderStalker = true;
							});
						}
					} else {
						if (ctrl.showHeaderStalker) {
							$timeout(function () {
								ctrl.showHeaderStalker = false;
							});
						}
					}
				}
			}
		});

		this.getWidgetId = function (row) {
			if (row.listing_id) {
				return 'listing-' + row.listing_id + ';building-' + row.building_id;
			} else if (row.id) {
				return 'building-' + row.id;
			}
			return '';
		};

		this.submit = function (sorting) {
			if (this.sortType === 'noxhr') {
				if (sorting.dir === 1) {
					this.orderProp = '-' + sorting.id;
					// this.orderProp = '-sale.price_raw';
				} else if (sorting.dir === 2) {
					this.orderProp = sorting.id;
					// this.orderProp = 'sale.price_raw';
				}
				this.currentSort = sorting.sort;

				this.onSubmit({ val: sorting });
			} else {
				this.onSubmit({ val: sorting });
			}
		};

		this.toggleExpand = function (item, e) {
			this.onToggleExpand({ listing: item, $event: e });
		};

		this.saveScrollPosition = function () {
			this.onSaveScrollPosition();
		};

		this.expandAll = function () {
			this.onExpandAll();
		};

		this.collapseAll = function () {
			this.onCollapseAll();
		};

		this.changeExpand = function () {
			this.onChangeExpand();
		};

		this.savePhotoOptionView = function () {
			this.onSavePhotoOptionView();
		};

		this.add = function (item, index, row) {
			var agent = {
				index: index
			};
			agent = angular.extend({}, agent, item);

			row.isLoading = true;

			crResourcesService.post(this.rpcUrlAdd, agent).then(function (data) {
				// todo
				if (data.success) {
					ctrl.rows[index] = agent;

					ctrl.onAdd({
						index: index,
						agent: agent,
						folios: data.agents
					});
				}
			}, function (error) {
				// todo manage errors
			}).finally(function () {
				row.isLoading = false;
			});
		};

		this.remove = function (index, row) {
			var data = {};
			data = angular.extend({}, data, row);

			var urlRemove = this.rpcUrlRemove;

			if (this.activePortfolio) {
				urlRemove += '?t=' + row.token;

				angular.forEach(row.portfolioList, function (folio) {
					if (folio.shared && folio.token !== ctrl.activePortfolio.token) {
						urlRemove += '&p[]=' + folio.token;
					}
				});
			}

			row.isLoading = true;

			// retreive the right index..
			var index;
			for (var i = 0; i < this.rows.length; i++) {
				if (row === this.rows[i]) {
					index = i;
					break;
				}
			}

			crResourcesService.post(urlRemove, data).then(function (res) {
				if (res.success || res.status) {
					ctrl.rows.splice(index, 1);

					ctrl.onRemove({
						index: index,
						folios: res.agents
					});
				}
			}, function (error) {
				// todo manage errors
			}).finally(function () {
				row.isLoading = false;
			});
		};

		this.swipe = function (index, row) {
			if (this.isMobile && !row.empty) {
				this.remove(index, row);
			}
		};

		this.openEditStatus = function (item) {
			this.onOpenEditStatus({ listing: item });
		};

		this.changeStatus = function (item, action) {
			this.onChangeStatus({ listing: item, action: action });
		};

		this.openRentStatus = function (item) {
			this.onOpenRentStatus({ listing: item });
		};

		this.editListing = function (item, $event) {
			$event && $event.preventDefault();

			// this will trigger the popup
			// however it is through many layers of PubSub and it is hard to pass $event on every layer
			if ($event && $event.currentTarget)
				Core.adaUtility.setTriggerForPopup($event.currentTarget);

			this.onEditListing({ listing: item }, $event);
		};

		this.changeAlert = function (item) {
			this.onChangeAlert({ listing: item });
		};

		this.manageListings = function (item) {
			this.onManageListings({ building: item });
		};

		this.repeatDone = function () {
			ctrl.onRepeatDone();
		};

		this.openOffMarketPopup = (popupName) => {
			PubSub.publish('cr-popup-open-' + popupName);
		};


		this.displayListingAddress = (listing) => {
			let address = '';

			let bedrooms = '';
			if (listing.bedrooms) {
				bedrooms = listing.bedrooms;
				if (listing.bedrooms != 'Studio') {
					bedrooms += ' bd at ';
				}
			}
			address = (bedrooms ? bedrooms + ' ' : '') + listing.display_name;

			return address;
		};

		this.renderClosingPriceRange = (closing_stats) => {
			const { range } = closing_stats;
			let arr = [range.min, range.max];
			if (range.min === range.max)
				arr = [range.min];
			const tmp = arr
				.filter((d) => !!d)
				.map((d) => '$' + $filter('shortNumber')(d, 1));
			return tmp.join(' - ');
		};

		this.lastListingRendered = (lastListingId) => {
			var _data = { 'listings': ctrl.rows, 'view': $scpe.type, 'pagination': ctrl.pagination, 'searchType': ctrl.searchType, 'singlePage': ctrl.singlePage, 'lastListingId': lastListingId };
			$scpe.$emit('lastListingRendered', _data);
		};

		this.buildingsBlimps = [];
		this.openBuildingGalleryPopup = (event) => {
			let link = event.target.closest('.w_blimp_building_gallery');
			let buildingId = link.getAttribute('data-building-id');
			if (!!buildingId && !!this.buildingsBlimps[buildingId]) {
				this.buildingsBlimps[buildingId].handle_link_click();
				this.buildingsBlimps[buildingId].show_widget('gallery');
				if (this.buildingsBlimps[buildingId].pagePhotogallery && this.buildingsBlimps[buildingId].pagePhotogallery.pg && this.buildingsBlimps[buildingId].pagePhotogallery.pg.current_index) {
					this.buildingsBlimps[buildingId].pagePhotogallery.pg.scrollMainToPosition(this.buildingsBlimps[buildingId].pagePhotogallery.pg.current_index);
				}
			} else if (!!buildingId && !this.buildingsBlimps[buildingId]) {
				this.buildingsBlimps[buildingId] = new BlimpExtV2(link , {
					cache: true,
					draggable: true,
					show_veil: false,
					fullscreen: true,
					display: 'gallery',
					onPostRpc: function() {
						this.add_extra(true);
						Core.compile_html(this._element);
					}
				});
				this.buildingsBlimps[buildingId].handle_link_click();
			}
		};
		
		this.listingBlimps = [];
		this.openListingGalleryPopup = (event, row, display = 'gallery') => {
			let link = event.target.closest('.price_history_listing_gallery_link');
			let listingId = null
			if (row.listing) listingId = row.listing.listing_id;
			if (row.listing_id) listingId = row.listing_id;
			
			if (!!listingId && !!this.listingBlimps[listingId]) {
				this.listingBlimps[listingId].handle_link_click();
				this.listingBlimps[listingId].show_widget(display);
				if (this.listingBlimps[listingId].pagePhotogallery && this.listingBlimps[listingId].pagePhotogallery.pg && this.listingBlimps[listingId].pagePhotogallery.pg.current_index) {
					this.listingBlimps[listingId].pagePhotogallery.pg.scrollMainToPosition(this.listingBlimps[listingId].pagePhotogallery.pg.current_index);
				}
			} else if (!!listingId && !this.listingBlimps[listingId]) {
				this.listingBlimps[listingId] = new BlimpExtV2(link , {
					cache: true,
					draggable: true,
					show_veil: false,
					fullscreen: true,
					display: display,
					onPostRpc: function() {
						this.add_extra(true);
						Core.compile_html(this._element);
					}
				});
				this.listingBlimps[listingId].handle_link_click();
			}
		};
		this.openListingPricingHistoryPopup = (event, row) => {
			let link = event.target.closest('.price_history_listing_gallery_link');
			let listingId = row.listing_id;
			
			if (!!listingId && !!this.listingBlimps[listingId]) {
				this.listingBlimps[listingId].handle_link_click();
				this.listingBlimps[listingId].show_widget('gallery');
				if (this.listingBlimps[listingId].pagePhotogallery && this.listingBlimps[listingId].pagePhotogallery.pg && this.listingBlimps[listingId].pagePhotogallery.pg.current_index) {
					this.listingBlimps[listingId].pagePhotogallery.pg.scrollMainToPosition(this.listingBlimps[listingId].pagePhotogallery.pg.current_index);
				}
			} else if (!!listingId && !this.listingBlimps[listingId]) {
				this.listingBlimps[listingId] = new BlimpExtV2(link , {
					cache: true,
					draggable: true,
					show_veil: false,
					fullscreen: true,
					display: 'phistory',
					onPostRpc: function() {
						this.add_extra(true);
						Core.compile_html(this._element);
					}
				});
				this.listingBlimps[listingId].handle_link_click();
			}
		};
		this.openListingDescriptionPopup = (event, row) => {
			let link = event.target.closest('.price_history_listing_description_link');
			let listingId = row.listing.listing_id + '-description';
			
			if (!!listingId && !!this.listingBlimps[listingId]) {
				this.listingBlimps[listingId].handle_link_click();
				this.listingBlimps[listingId].show_widget('gallery');
				if (this.listingBlimps[listingId].pagePhotogallery && this.listingBlimps[listingId].pagePhotogallery.pg && this.listingBlimps[listingId].pagePhotogallery.pg.current_index) {
					this.listingBlimps[listingId].pagePhotogallery.pg.scrollMainToPosition(this.listingBlimps[listingId].pagePhotogallery.pg.current_index);
				}
			} else if (!!listingId && !this.listingBlimps[listingId]) {
				this.listingBlimps[listingId] = new BlimpExtV2(link , {
					cache: true,
					draggable: true,
					show_veil: false,
					opaque_popup: true,
					fullscreen: true,
					display: 'gallery',
					put_others_behind: true,
					onPostRpc: function() {
						this.add_extra(true);
						Core.compile_html(this._element);
					}
				});
				this.listingBlimps[listingId].handle_link_click();
			}
		};
	}]
});
